<template>
  <v-container>
    <v-subheader class="text-subtitle-1 font-weight-bold grey--text text--darken-2">
      <v-icon color="blue darken-2">mdi-clock-outline</v-icon>
      <span class="ml-2">{{$t('lang.registration')}}</span>
    </v-subheader>
    <div v-if="showBtn">
      <div class="d-none d-md-flex my-4 flex-wrap">
        <v-btn class="ma-2 ma-lg-4 px-8 white--text" style="text-transform:none;" color="#FD8816" @click="expire()">{{$t('lang.register')}}</v-btn>
        <!-- <v-btn class="ma-2 ma-lg-4 px-8 white--text" style="text-transform:none;" color="#FD8816" :href="submitUrl + 'id=' + data.Kid + '&applyId=3'">{{$t('lang.register')}}</v-btn> -->
        <v-btn class="ma-2 ma-lg-4 px-8" color="primary" style="text-transform:none;" @click="selectComponent(true, 1)" v-if="data.IsSelect == 1">{{$t('lang.query')}}</v-btn>
        <v-btn class="ma-2 ma-lg-4 px-8" color="primary" style="text-transform:none;" @click="selectComponent(true, 2)" v-if="data.IsEdit == 1">{{$t('lang.modify')}}</v-btn>
        <!--去掉了 v-if="data.IsNeedPay == 1" -->
        <v-btn v-if="data.IsNeedPay == 1" class="ma-2 ma-lg-4 px-8" color="primary" style="text-transform:none;" :loading="loading" @click="selectComponent(true, 5)">{{$t('lang.pay')}}</v-btn>
        <v-btn class="ma-2 ma-lg-4 px-8" color="primary" style="text-transform:none;" @click="selectComponent(true, 3)" v-if="data.IsRefund == 1">{{$t('lang.refund')}}</v-btn>
        <v-btn class="ma-2 ma-lg-4 px-8" color="primary" style="text-transform:none;" v-if="data.IsNeedInvoicing == 1" target="_blank" :href="data.InvoicingLink.indexOf('http://') === -1 && data.InvoicingLink.indexOf('https://') === -1 ? 'http://' + data.InvoicingLink : data.InvoicingLink">{{$t('lang.invoice')}}</v-btn>
        <!-- <v-btn class="ma-2 ma-lg-4 px-8" color="primary" style="text-transform:none;" :to="{name: 'Checkin', query:{id: data.Sid}}">{{$t('lang.signIn')}}</v-btn> -->
        <v-btn class="ma-2 ma-lg-4 px-8" color="primary" style="text-transform:none;" @click="sign()" v-if="data.IsNeedMeetingSign == 0">{{$t('lang.signIn')}}</v-btn>
      </div>
      <v-row dense class="d-md-none">
        <v-col cols="10" class="my-2">
          <v-btn class="ml-6 white--text" style="text-transform:none;" block color="#FD8816" @click="expire()">{{$t('lang.register')}}</v-btn>
        </v-col>
        <v-col cols="10" class="my-2" v-show="data.IsSelect == 1">
          <v-btn class="ml-6" style="text-transform:none;" block color="primary" @click="selectComponent(true, 1)">{{$t('lang.query')}}</v-btn>
        </v-col>
        <v-col cols="10" class="my-2" v-if="data.IsEdit == 1">
          <v-btn class="ml-6" style="text-transform:none;" block color="primary" @click="selectComponent(true, 2)">{{$t('lang.modify')}}</v-btn>
        </v-col>
        <v-col cols="10" class="my-2">
          <v-btn v-if="data.IsNeedPay == 1" class="ml-6" style="text-transform:none;" block color="primary" :loading="loading" @click="selectComponent(true, 5)">{{$t('lang.pay')}}</v-btn>
        </v-col>
        <v-col cols="10" class="my-2" v-if="data.IsRefund == 1">
          <v-btn class="ml-6" style="text-transform:none;" block color="primary" @click="selectComponent(true, 3)">{{$t('lang.refund')}}</v-btn>
        </v-col>
        <v-col cols="10" class="my-2" v-if="data.IsNeedInvoicing == 1">
          <v-btn class="ml-6" style="text-transform:none;" block color="primary" target="_blank" :href="data.InvoicingLink.indexOf('http://') === -1 && data.InvoicingLink.indexOf('https://') === -1 ? 'http://' + data.InvoicingLink : data.InvoicingLink">{{$t('lang.invoice')}}</v-btn>
        </v-col>
        <v-col cols="10" class="my-2">
          <!-- <v-btn class="ml-6" style="text-transform:none;" block color="primary" :to="{name: 'Checkin', query:{id: data.Sid}}">{{$t('lang.signIn')}}</v-btn> -->
          <v-btn class="ml-6" style="text-transform:none;" block color="primary" @click="sign()" v-if="data.IsNeedMeetingSign == 0">{{$t('lang.signIn')}}</v-btn>
        </v-col>
      </v-row>
    </div>
    <component :is="component" :data="data" @pay="gotoPay()" @showDialog="showDialog" @showSnack="showSnack" @fatherEvent="showBtn=true;component=null"></component>
    <v-snackbar v-model="snackbar" timeout="2000" centered color="primary" multi-line>
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          {{$t('lang.close')}}
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="dialog" persistent max-width="290" transition="dialog-top-transition">
      <v-card>
        <v-card-title class="headline">{{$t('lang.tips')}}</v-card-title>
        <v-card-text v-html="msg" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"  @click="dialog = false; if (fromSignUp) gotoPay()">
            {{$t('lang.confirm')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Login v-if="login" :id="data.SignUpId" @showSnack="showSnack" @fatherEvent="login=false;if ($store.getters.getLogin) selectComponent(true, componentIndex)"></Login>
    <Login4Sign v-if="login4Sign" :id="data.SignUpId" @showSnack="showSnack" @fatherEvent="login4Sign=false;if ($store.getters.getLogin) sign()"></Login4Sign>
  </v-container>
</template>
<style>
.v-card__text {
  white-space: pre-wrap;
}
.v-btn__content {
  width: 100%;
  white-space: normal;
}
</style>
<script>
import SignUp from '@/components/SignUp'
import Query from '@/components/Query'
import Modify from '@/components/Modify'
import Refund from '@/components/Refund'
import Invoice from '@/components/Invoice'
import Pay from '@/components/Pay'
import urls from '../utils/urls'
import utils from '../utils/utils.js'
import Login from '@/components/Login'
import Login4Sign from '@/components/Login4Sign'
export default {
  name: 'Register',
  props: ['data', 'back', 'signUp'],
  components: {
    SignUp,
    Query,
    Modify,
    Refund,
    Invoice,
    Login,
    Login4Sign,
    Pay
  },
  watch: {
    back (val) {
      this.showBtn = true
      this.component = null
    },
    signUp (val) {
      if (val) {
        this.expire()
      }
    }
  },
  data: () => ({
    dialog: false,
    fromSignUp: false,
    snackbar: false,
    msg: '',
    login: false,
    loading: false,
    login4Sign: false,
    submitUrl: urls.lijiaobaoming,
    signUrl: urls.huiyiqiandao,
    bool: true,
    showBtn: true,
    component: undefined,
    componentIndex: -1, // -2表示会议缴费
    components: [SignUp, Query, Modify, Refund, Invoice, Pay]
  }),
  mounted () {
    const _this = this
    window.addEventListener('storage', function (e) {
      _this.$store.commit('setLogin', false)
      _this.sign()
    })
    if (this.signUp && !this.$store.getters.getLogin4SignAgain && !this.$store.getters.getBackFromCheckin) {
      this.expire()
    }
    this.$store.commit('setBackFromCheckin', false)
    if (this.$store.getters.getLogin4SignAgain) {
      this.$store.commit('setLogin4SignAgain', false)
      this.sign()
    }
  },
  methods: {
    gotoPay () {
      this.fromSignUp = false
      // if (this.getPayUrl()/* && this.$store.getters.getTotalFee !== '0' */) {
      //   if (this.$store.getters.getLanguage === 0 && utils.methods.isMobile() && !this.isWeiXin()) {
      //     this.msg = '请在电脑端打开链接，点击“会议缴费”完成缴费操作。'
      //     this.snackbar = true
      //   } else {
      //     // this.component = this.components[5]
      //     // window.location.href = this.getPayUrl()
      //   }
      // }
      // this.selectComponent(false, 5)
      this.showBtn = false
      if (this.$store.getters.getTotalFee !== 0 && this.$store.getters.getTotalFee !== '0') {
        this.component = this.components[5]
      } else {
        this.showBtn = true
        this.component = null
      }
    },
    isWeiXin () {
      const ua = window.navigator.userAgent.toLowerCase()
      if (ua.indexOf('micromessenger') !== -1) {
        return true
      } else {
        return false
      }
    },
    getPayUrl () {
      let web = this.$store.getters.getPayUrlForWeb
      let h5 = this.$store.getters.getPayUrlForH5
      if (this.$store.getters.getLanguage !== 0) {
        web = ''
        h5 = ''
      }
      return utils.methods.isMobile() ? h5 : web
    },
    selectComponent (checkLogin, num) {
      if (checkLogin && !this.$store.getters.getLogin) {
        this.componentIndex = num
        this.login = true
      } else {
        if (num === -2) {
          this.pay()
        } else if (num === 5) {
          this.isPayed()
        } else {
          this.showBtn = false
          this.component = this.components[num]
        }
      }
    },
    sign () {
      if (!this.$store.getters.getLogin) {
        this.login4Sign = true
      } else {
        if (utils.methods.isMobile()) {
          this.$router.push('/Checkin')
        } else {
          const routeData = this.$router.resolve({
            name: 'Checkin'
          })
          window.open(routeData.href, '_blank')
        }
      }
    },
    expire () {
      if (!utils.methods.expire(this.data.StartTime)) {
        this.msg = this.$store.getters.getLanguage === 0 ? '当前报名尚未开始' : 'Registration has not started yet.'
        this.dialog = true
      } else if (utils.methods.expire(this.data.EndTime)) {
        this.msg = this.$store.getters.getLanguage === 0 ? '当前报名已经结束' : 'Registration is over.'
        this.dialog = true
      } else {
        this.selectComponent(false, 0)
      }
    },
    pay () {
      if (this.$store.getters.getLanguage !== 0) {
        this.msg = 'Please pay by transfer.'
        this.dialog = true
      } else {
        // console.log(this.$store.getters.getPayUrlForH5)
        // if (!this.$store.getters.getPayUrlForH5) {
        //   this.msg = this.$store.getters.getLanguage === 0 ? '您暂不需要支付费用或费用已支付。' : 'You do not need to pay or the fee has been paid.'
        //   this.snackbar = true
        // } else {
        //   this.gotoPay()
        // }
        this.gotoPay()
      }
    },
    isPayed () {
      this.loading = true
      this.$http.get('/SignUp/SearchUserSignup', {
        requestBase: 'VUE_APP_API',
        params: {
          UserName: this.$store.getters.getUserName,
          Phone: this.$store.getters.getPhoneOrEmail,
          SignUpId: this.$store.getters.getSignUpId
        }
      }).then(res => {
        this.loading = false
        if (res.data.ret === 0) {
          console.log(res)
          const payState = res.data.data.PayState
          if (res.data.data.PayUrlForH5) {
            this.$store.commit('setPayUrlForH5', res.data.data.PayUrlForH5 + '&backurl=' + this.getInvoicingLink() + '&backname=' + this.getInvoicingName())
          } else {
            this.$store.commit('setPayUrlForH5', '')
          }
          if (res.data.data.PayUrlForWeb) {
            this.$store.commit('setPayUrlForWeb', res.data.data.PayUrlForWeb + '&backurl=' + this.getInvoicingLink())
          } else {
            this.$store.commit('setPayUrlForWeb', '')
          }
          if (payState === 1 || payState === 6) {
            this.$store.commit('setTotalFee', res.data.data.PayMoney)
            this.pay()
          } else {
            this.msg = this.$store.getters.getLanguage === 0 ? '您暂不需要支付费用或费用已支付。' : 'You do not need to pay or the fee has been paid.'
            this.snackbar = true
            this.loading = false
          }
        } else {
          this.msg = res.data.msg
          this.snackbar = true
        }
      }).catch(e => {
        this.loading = false
        this.msg = 'error'
        this.snackbar = true
        console.log(e)
      })
    },
    getInvoicingLink () {
      let url = ''
      if (this.$store.getters.getData.InvoicingLink) {
        url = this.$store.getters.getData.InvoicingLink.indexOf('http://') === -1 && this.$store.getters.getData.InvoicingLink.indexOf('https://') === -1 ? 'http://' + this.$store.getters.getData.InvoicingLink : this.$store.getters.getData.InvoicingLink
      } else {
        url = window.location.href
      }
      return encodeURIComponent(url)
    },
    getInvoicingName () {
      if (this.$store.getters.getData.InvoicingLink) {
        return encodeURIComponent('预约开票')
      } else {
        return encodeURIComponent('返回')
      }
    },
    showSnack (val) {
      this.msg = val
      this.snackbar = true
    },
    showDialog (val, fromSignUp) {
      this.fromSignUp = fromSignUp
      this.msg = val
      this.dialog = true
    }
  }
}
</script>
